<template>
  <div class="goods-item-wrap">
    <!-- @click="openDetail"  -->
    <a :href="itemLink" :target="goodsTarget" rel="noopener noreferrer" class="goods-info-wrap" @click="reportRecommendClick">
      <LazyImage  :src="item.pic ? item.pic : ''" class="goods-pic" />
      <img
        v-if="platformLogo"
        class="goods-type-icon"
        :src="platformLogo"
        :alt="item.iconType"
        referrerpolicy="no-referrer"
      >
      <div v-else class="goods-type">{{item.iconType}}</div>
      <div class="goods-title">{{item.title}}</div>
      <span v-if="item.buyerName" class="goods-buyer">{{ $t('texts.buyer') }}: {{ item.buyerName }}</span>
    </a>

   
    <a
      :href="itemLink"
      :target="goodsTarget"
      rel="noopener noreferrer"
      style="width: 169px;"
      class="goods-price"
      @click="reportRecommendClick"
    >{{ item.finalPrice }} {{$t('unit.yuan')}}  <template v-if="getCurrencySymbol('¥')!='¥'">（{{ getCurrencyNum(item.finalPrice) }} {{getCurrencySymbol('¥')}}）</template></a>
    <a
      v-if="!hideSales"
      :href="itemLink"
      :target="goodsTarget"
      rel="noopener noreferrer"
      style="width: 92px;"
      class="goods-sales-num"
      @click="reportRecommendClick"
    >{{item.salesNum}}</a>
    <a  :target="isTarget_Blank()" :href="makeOpenImgToSearch(item.imageUrl || item.pic, item.platform)" class="popover-wrap">
      <img class="popover-img" src="/assets/imgs/indexImageSearch.svg" />
    </a>
  </div>
</template>
    
<script setup>
import useLocate from "@/components/render/uses/useLocate.js";
import { ElScrollbar } from "element-plus";
import { useMainStore } from "@/composables/store";
import { getCurrencySymbol,getCurrencyNum } from "@/utils/goods";
import { isTarget_Blank } from "@/utils/globalData";
import { $t } from "~/utils/index.js";
import { computed, inject } from "vue";
import { useRoute } from "vue-router";
import { mallAnalyticsLogEvent } from "@/utils/mallEventLog.js";
import { trackLowCodeEvent } from "@/utils/lowCodeTracking.js";
import { buildGoodsClickTrackingParams } from "./goodsClickTracking.js";
import icon1688 from "@user-center/assets/img/expertPurchase/icon-1688.png";
import iconJd from "@user-center/assets/img/expertPurchase/icon-jd.png";
import iconPdd from "@user-center/assets/img/expertPurchase/icon-pdd.png";
import iconTb from "@user-center/assets/img/expertPurchase/icon-tb.png";
import iconXhs from "@user-center/assets/img/expertPurchase/icon-xhs.png";
import iconWeidian from "@user-center/assets/img/expertPurchase/icon-wd.png";
import iconXfish from "@user-center/assets/img/expertPurchase/icon-xfish.png";

import LazyImage from  "@/components/common/LazyImage/index.vue"
let { langJson, nowLocale, getLocaleText } = useLocate();
 

// 接收props
const props = defineProps({
  item: {
    type: Object,
    default: () => ({})
  },
  rank: { type: Number, default: 0 },
  source: { type: String, default: "system" },
  openNewWindow: { type: Boolean, default: undefined },
  hideSales: { type: Boolean, default: false },
  trackingConfig: { type: Object, default: undefined },
  trackingElement: { type: Object, default: () => ({}) },
  elementIndex: {
    type: [Array, String, Number],
    default: "mall_goods_card_item",
  },
});
const route = useRoute();
const getConfigJson = inject("getConfigJson", () => ({}));
const itemLink = computed(() => {
  return props.item?.link || `/product?detailId=${props.item?.id || ""}`;
});
const goodsTarget = computed(() => {
  return typeof props.openNewWindow === "boolean"
    ? (props.openNewWindow ? "_blank" : "_self")
    : isTarget_Blank();
});

function normalizePlatform(value) {
  return String(value ?? "").trim().toLowerCase();
}

const platformLogo = computed(() => {
  const platform = normalizePlatform(props.item?.platform || props.item?.iconType);
  const orderSource = normalizePlatform(props.item?.orderSource);
  const values = [platform, orderSource];

  if (values.some(value => ["taobao", "tb", "淘宝", "1"].includes(value))) return iconTb;
  if (values.some(value => ["1688", "alibaba", "阿里巴巴", "2", "4"].includes(value))) return icon1688;
  if (values.some(value => ["jd", "jingdong", "京东"].includes(value))) return iconJd;
  if (values.some(value => ["pdd", "pinduoduo", "拼多多", "3"].includes(value))) return iconPdd;
  if (values.some(value => ["xhs", "xiaohongshu", "小红书", "5"].includes(value))) return iconXhs;
  if (values.some(value => ["weidian", "wd", "微店", "7"].includes(value))) return iconWeidian;
  if (values.some(value => ["goofish", "xianyu", "闲鱼", "fish", "6", "8"].includes(value))) return iconXfish;
  return "";
});
function reportRecommendClick() {
  const page = typeof getConfigJson === "function" ? getConfigJson() : {};
  const eventParams = buildGoodsClickTrackingParams(
    props.item,
    props.rank,
    props.source,
  );
  trackLowCodeEvent(props.trackingConfig, {
    trigger: "click",
    element: props.trackingElement,
    elementType: "mall_goods_card_item",
    elementIndex: props.elementIndex,
    page,
    binding: {
      ...(page?.bindData || {}),
      goodsData: props.item,
      goodsIndex: Math.max(0, props.rank - 1),
    },
    runtime: {
      goodsIndex: Math.max(0, props.rank - 1),
      platformType: props.item?.platform || props.item?.iconType,
    },
    eventParams,
  });
}

// 图搜
function makeOpenImgToSearch(url, platform) {
  if (!url) return "";
  const platformQuery =
    String(platform || "").trim() === "taobao" ? "&platform=taobao" : "";
  return '/product/search?searchType=img&imgSrc='+encodeURIComponent(url)+platformQuery;
}
</script>
    
  
<style scoped lang="less">
.goods-item-wrap {
  padding: 5px;
  display: flex;
  height: 52px;
  border-radius: 4px;
  background: #fff;
  margin-bottom: 5px;
  position: relative;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.36);
    .popover-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 16px;
      right: 14px;
      width: 32px;
      height: 32px;
      cursor: pointer;
      background: #fff;
      border-radius: 4px;
      .popover-img {
        width: 26px;
        height: 26px;
      }
    }
  }
  .popover-wrap {
    display: none;
  }
  .goods-info-wrap {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 100px;
    padding: 0 30px 0 0;
    .goods-pic {
      width: 50px;
      height: 50px;
      min-width: 50px;
      min-height: 50px;
      margin-right: 12px;
    }
    .goods-type-icon {
      width: 18px;
      height: 18px;
      min-width: 18px;
       vertical-align: middle;
      object-fit: contain;
      margin-right: 4px;
    }
    .goods-type {
      width: 46px;
      height: 18px;
      display: inline-block;
      background: #ff4000;
      border-radius: 2px;
      margin-right: 7px;
      text-align: center;
      line-height: 18px;
      font-weight: 700;
      color: #fff;
    }
    .goods-title {
      color: #000;
      font-size: 14px;
      flex: 1;
      min-width: 100px;
      overflow: hidden;

      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .goods-buyer {
      flex: 0 0 auto;
      margin-left: 8px;
      color: #666;
      font-size: 12px;
      white-space: nowrap;
    }
  }
  .goods-price {
      font-size: 18px;
    font-weight: bold;
    color: var(--el-color-primary);
  }
  .goods-sales-num {
    font-size: 14px;
    color: #333;
  }
}
</style>
